(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CustomerUserType', CustomerUserType);

    CustomerUserType.$inject = ['$resource'];

    function CustomerUserType ($resource) {
        var resourceUrl =  'api/customer-user-type/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getWithoutSingleUser':{
            	method:'GET',
            	url:'api/customer-user-type-multi',
            	isArray : true
            }
        });
    }
})();
